import { render } from "./DutyPermissionsContent.vue?vue&type=template&id=17f1fff0&scoped=true&ts=true"
import script from "./DutyPermissionsContent.vue?vue&type=script&lang=ts"
export * from "./DutyPermissionsContent.vue?vue&type=script&lang=ts"

import "./DutyPermissionsContent.vue?vue&type=style&index=0&id=17f1fff0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f1fff0"]])

export default __exports__